import React from 'react';

import { connect } from 'react-redux';
import swal from 'sweetalert2';

import { bindActionCreators } from 'redux';

import RetinaImage from 'react-retina-image';
import Menu from './Menu';
import ProgressBar from './ProgressBar';

import * as actionCreators from '../actions';

import 'sweetalert2/dist/sweetalert2.min.css';
import './Header.css';

const onClickSignOut = (props) => {
  swal({
    title:'<div style="background-color: ' + window.whiteLabel.mainColor +'; color: #ffffff; padding: 10px; font-weight: normal  ;">Sair?</div>',
    showCancelButton: true,
    confirmButtonText: 'Sim',
    customClass: 'alert',
    confirmButtonClass: 'confirm-btn',
    cancelButtonText: 'Cancelar'
  }).then(() => props.signOut())
};

const resetMap = (props) => {
  props.selecionaToastAlerta({});
  props.atualizaLocalizacao({ lat: -19.919123, lng: -43.938833 }, 20, 'km')
}

const Header = (props) => {
  return (
    <header className="mdl-layout__header main-header">
      <div className={`blocker ${ props.isReady ? '' : 'is-loading' }`}></div>
      <div className="mdl-layout__header-row">
        <div className="title-area" onClick={ () => resetMap(props) }>
          <div className="mdl-layout-title">
            <RetinaImage className="logo" src={ window.whiteLabel.logoBar } />
          </div>
        </div>

        <Menu { ...props } />

        <div className="mdl-layout-spacer"></div>
        <nav className="mdl-navigation">
          <div className="mdl-navigation stores right-item">
          {/* <RetinaImage className="logo" src={logoPbh} /> */}
          </div>
          <div className="mdl-navigation stores right-item">
          {/* <RetinaImage className="logo" src={logoCopbh} /> */}
          </div>
          <div className="mdl-navigation__link stores container-sair" onClick={ () => onClickSignOut(props) }>
          <a>
            Sair
          </a>
          </div>
        </nav>
      </div>
      <ProgressBar style={{ display: props.isReady ? 'none' : 'block' }} />
    </header>
  );
};

const mapDispatchToProps = (dispatch) => bindActionCreators(actionCreators, dispatch);
export default connect(null, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js